<template>
    <div class="login-page">
        <!-- Left: Image -->
        <div class="login-visual">
            <div class="login-visual-overlay"></div>
            <div class="login-visual-content">
                <div class="login-visual-slider">
                    <transition name="slide-vertical" mode="out-in">
                        <h2 class="login-visual-title" :key="currentSlide">
                            {{ slides[currentSlide] }}
                        </h2>
                    </transition>
                </div>
                <p class="login-visual-text">Votre plateforme de gestion communautaire</p>
            </div>
        </div>

        <!-- Right: Form -->
        <div class="login-form-side">
            <div class="login-form-wrapper">
                <div class="login-form-logo">
                    <img src="@/assets/logo.jpg" alt="Logo" class="login-mobile-logo" />
                </div>
                <h1 class="login-title">
                    {{ isForgotPassword ? $t('auth.forgot_password.submit') : $t('auth.login') }}
                </h1>
                <p class="login-subtitle">
                    {{ isForgotPassword ? 'Un lien de réinitialisation sera envoyé' : 'Accédez à votre tableau de bord' }}
                </p>

                <form @submit.prevent="isForgotPassword ? forgotPasswordHandler() : connection()">
                    <div class="form-group">
                        <label for="email">{{ $t('auth.email') }}</label>
                        <input
                            id="email"
                            v-model="email"
                            autocomplete="email"
                            autofocus
                            :placeholder="'votre@email.com'"
                            required
                            type="email"
                        />
                        <span v-if="(isForgotPasswordSubmit && mailMessage) || (isSubmit && mailMessage)" class="form-error">
                            {{ mailMessage }}
                        </span>
                    </div>

                    <div class="form-group" v-if="!isForgotPassword">
                        <label for="password">{{ $t('auth.reset_password.password') }}</label>
                        <div class="password-wrapper">
                            <input
                                id="password"
                                v-model="password"
                                autocomplete="current-password"
                                :placeholder="'••••••••'"
                                required
                                :type="showPassword ? 'text' : 'password'"
                            />
                            <i
                                :class="showPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                                class="password-toggle"
                                @click="showPassword = !showPassword"
                            ></i>
                        </div>
                        <span v-if="isSubmit && passwordMessage" class="form-error">
                            {{ passwordMessage }}
                        </span>
                    </div>

                    <div class="forgot-row" v-if="!isForgotPassword">
                        <span class="forgot-link" @click.prevent="clean()">
                            {{ $t('auth.forgot_password.submit') }}
                        </span>
                    </div>

                    <div v-if="isForgotPasswordSubmit && passwordResetMessage" class="form-success">
                        <i class="fal fa-check-circle"></i> {{ passwordResetMessage }}
                    </div>

                    <button type="submit" class="btn-submit" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                        {{ isForgotPassword ? $t('auth.forgot_password.send_request') : $t('auth.login') }}
                    </button>

                    <div class="back-link" v-if="isForgotPassword">
                        <span @click.prevent="clean()">
                            <i class="fal fa-long-arrow-left mr-1"></i> Retour à la connexion
                        </span>
                    </div>
                </form>
            </div>
        </div>

        <Toaster ref="toaster" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Toaster from '@/components/UI/Helper/Toaster'

export default {
    name: 'LoginSanctum',
    components: {
        Toaster
    },
    data: function () {
        return {
            email: '',
            password: '',
            isSubmit: false,
            isloadingForgotPwd: false,
            loading: false,
            backendUrl: process.env.VUE_APP_BACKEND_URL,
            mailMessage: '',
            passwordMessage: '',
            passwordResetMessage: '',
            isForgotPasswordSubmit: false,
            isForgotPassword: false,
            showPassword: false,
            currentSlide: 0,
            slides: [
                'Votre plateforme de gestion communautaire',
                'Suivez vos tickets en temps réel',
                'Gérez vos formulaires et vos équipes',
                'Analysez vos performances'
            ],
            slideInterval: null,
            mailregExp:
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        }
    },
    computed: {
        errorWrongPasswordOrEmail() {
            return this.$t('error.validation.wrong_password_or_email')
        },
        errorContactManager() {
            return this.$t('error.contact_manager')
        },
        errorTitle() {
            return this.$t('error.title_error')
        }
    },
    methods: {
        ...mapActions('auth', ['login', 'forgotPassword']),
        connection: function () {
            this.loading = true
            this.isSubmit = true
            this.confirmMail(this.email)
            this.confirmPassword(this.password)
            !this.mailMessage && !this.passwordMessage
                ? this.login({ email: this.email, password: this.password })
                      .then(() => {
                          this.loading = false
                          this.$router.push('/')
                      })
                      .catch((error) => {
                          error['message'] =
                              error.response.data.error ===
                              'Wrong username or password'
                                  ? this.errorWrongPasswordOrEmail
                                  : this.errorContactManager
                          error.response.data.error =
                              'Wrong username or password'

                          error['title'] = this.errorTitle

                          this.$store
                              .dispatch('dispatchError', error)
                              .then(() => {
                                  this.loading = false
                              })
                      })
                : (this.loading = false)
        },
        forgotPasswordHandler() {
            this.loading = true
            this.isForgotPasswordSubmit = true
            this.confirmMail(this.email)
            !this.mailMessage
                ? this.forgotPassword({ email: this.email })
                      .then(() => {
                          this.isloadingForgotPwd = false
                          this.passwordResetMessage = this.$t(
                              'auth.forgot_password.success_message'
                          )
                          this.loading = false
                      })
                      .catch((error) => {
                          this.isloadingForgotPwd = false
                          error['title'] = this.errorTitle
                          this.$store
                              .dispatch('dispatchError', error)
                              .then(() => {
                                  this.loading = false
                              })
                      })
                : (this.isloadingForgotPwd = false)
        },
        confirmMail(email) {
            if (!email) {
                this.mailMessage = this.$t('error.validation.required')
            } else if (!this.mailregExp.test(email)) {
                this.mailMessage = this.$t('error.validation.mail_valid')
            } else {
                this.mailMessage = ''
            }
        },
        confirmPassword(password) {
            if (!password) {
                this.passwordMessage = this.$t('error.validation.required')
            } else {
                this.passwordMessage = ''
            }
        },
        clean() {
            this.isForgotPassword = !this.isForgotPassword
            this.passwordResetMessage = ''
            this.passwordMessage = ''
            this.mailMessage = ''
            this.password = ''
        }
    },
    mounted() {
        this.slideInterval = setInterval(() => {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length
        }, 4000)
    },
    beforeDestroy() {
        if (this.slideInterval) clearInterval(this.slideInterval)
    }
}
</script>

<style scoped>
/* ── Layout ── */
.login-page {
    position: fixed;
    inset: 0;
    display: flex;
    font-family: var(--v2-font-sans, 'Inter', system-ui, -apple-system, sans-serif);
}

/* ── Left: Visual ── */
.login-visual {
    width: 50%;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
}

.login-visual::before {
    content: '';
    position: absolute;
    inset: 0;
    background: url('/img/img20.jpg') center / cover no-repeat;
    animation: slowZoom 15s ease-in-out infinite alternate;
}

@keyframes slowZoom {
    0% { transform: scale(1); }
    100% { transform: scale(1.1); }
}

.login-visual-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
        135deg,
        rgba(8, 145, 178, 0.35) 0%,
        rgba(15, 23, 42, 0.55) 45%,
        rgba(15, 23, 42, 0.9) 100%
    );
}

.login-visual-content {
    position: relative;
    z-index: 1;
    padding: 0 56px 56px;
}

.login-visual-title {
    color: #fff;
    font-size: 2.4rem;
    font-weight: 700;
    margin-bottom: 8px;
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.login-visual-slider {
    height: 58px;
    overflow: hidden;
}

.login-visual-text {
    color: rgba(255, 255, 255, 0.72);
    font-size: 1rem;
    margin: 0;
    letter-spacing: 0.005em;
}

/* Slide vertical transition */
.slide-vertical-enter-active,
.slide-vertical-leave-active {
    transition: all 0.4s ease;
}

.slide-vertical-enter {
    opacity: 0;
    transform: translateY(16px);
}

.slide-vertical-leave-to {
    opacity: 0;
    transform: translateY(-16px);
}

/* ── Right: Form ── */
.login-form-side {
    width: 50%;
    background: var(--v2-surface-2, #f1f5f9);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
}

.login-form-wrapper {
    width: 100%;
    max-width: 420px;
    background: var(--v2-surface-0, #fff);
    border: 1px solid var(--v2-border, #e2e8f0);
    border-radius: var(--v2-radius-xl, 16px);
    padding: 36px;
    box-shadow: var(--v2-shadow-lg, 0 8px 24px rgba(15, 23, 42, 0.08));
    box-sizing: border-box;
}

.login-form-wrapper form {
    width: 100%;
}

.login-form-logo {
    text-align: center;
    margin-bottom: 28px;
}

.login-mobile-logo {
    max-height: 56px;
    display: block;
    margin: 0 auto;
}

.login-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--v2-text-1, #0f172a);
    margin: 0 0 4px;
    letter-spacing: -0.02em;
    text-align: center;
}

.login-subtitle {
    color: var(--v2-text-3, #64748b);
    font-size: 0.88rem;
    margin: 0 0 28px;
    text-align: center;
}

/* ── Form ── */
.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v2-text-3, #64748b);
    margin-bottom: 8px;
}

.forgot-row {
    text-align: right;
    margin-top: -12px;
    margin-bottom: 20px;
}

.forgot-link {
    font-size: 0.82rem;
    color: var(--v2-primary, #0891b2);
    cursor: pointer;
    font-weight: 500;
    transition: color 0.15s;
}

.forgot-link:hover {
    color: var(--v2-primary-hover, #0e7490);
    text-decoration: underline;
}

.form-group input {
    display: block;
    width: 100%;
    padding: 12px 14px;
    border: 1px solid var(--v2-border, #e2e8f0);
    border-radius: var(--v2-radius-md, 8px);
    font-size: 0.95rem;
    color: var(--v2-text-1, #0f172a);
    background: var(--v2-surface-0, #fff);
    outline: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    box-sizing: border-box;
}

.password-wrapper {
    position: relative;
}

.password-wrapper input {
    padding-right: 44px;
}

.password-toggle {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--v2-text-4, #94a3b8);
    cursor: pointer;
    font-size: 1rem;
    transition: color 0.15s;
}

.password-toggle:hover {
    color: var(--v2-primary, #0891b2);
}

.form-group input::placeholder {
    color: var(--v2-text-4, #94a3b8);
}

.form-group input:focus {
    border-color: var(--v2-primary, #0891b2);
    box-shadow: var(--v2-shadow-focus, 0 0 0 3px rgba(8, 145, 178, 0.2));
}

.form-error {
    display: block;
    color: var(--v2-danger, #ef4444);
    font-size: 0.8rem;
    margin-top: 6px;
}

.form-success {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--v2-success, #10b981);
    font-size: 0.88rem;
    font-weight: 500;
    padding: 12px 14px;
    background: var(--v2-success-soft, rgba(16, 185, 129, 0.1));
    border: 1px solid var(--v2-success, #10b981);
    border-radius: var(--v2-radius-md, 8px);
    margin-bottom: 20px;
}

.form-success i {
    font-size: 1rem;
}

/* ── Button ── */
.btn-submit {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    background: var(--v2-primary, #0891b2);
    border: none;
    border-radius: var(--v2-radius-md, 8px);
    color: #fff;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    cursor: pointer;
    transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.btn-submit:hover:not(:disabled) {
    background: var(--v2-primary-hover, #0e7490);
    box-shadow: 0 4px 12px rgba(8, 145, 178, 0.25);
    transform: translateY(-1px);
}

.btn-submit:active:not(:disabled) {
    transform: translateY(0);
}

.btn-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ── Links ── */
.back-link {
    text-align: center;
    margin-top: 24px;
}

.back-link span {
    color: var(--v2-text-3, #64748b);
    font-size: 0.88rem;
    cursor: pointer;
    transition: color 0.15s;
}

.back-link span:hover {
    color: var(--v2-primary, #0891b2);
}

/* ── Responsive ── */
@media (max-width: 860px) {
    .login-page {
        flex-direction: column;
    }

    .login-visual {
        width: 100%;
        min-height: 220px;
    }

    .login-visual-content {
        padding: 0 32px 32px;
    }

    .login-visual-title {
        font-size: 1.4rem;
    }

    .login-form-side {
        width: 100%;
        padding: 32px 24px;
    }

    .login-form-wrapper {
        padding: 28px;
    }
}
</style>
